import { render } from "./index.vue?vue&type=template&id=b08acf12"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b08acf12&lang=css"

import exportComponent from "L:\\vuexiangmu\\oppt2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__